import React, { useContext, useState } from "react";
import { Box, Typography, Dialog, DialogActions, DialogContent, DialogTitle, Button, Checkbox, FormControlLabel, } from "@mui/material";
import Draggable from "react-draggable";
import { ThemeContext } from "../../context/ThemeContext";
import { CloseSharp } from "@mui/icons-material";

// Draggable Box component
const DraggableBox = React.forwardRef(({ children, ...props }, ref) => (
    <Draggable handle=".header">
        <div ref={ref} {...props}>{children}</div>
    </Draggable>
));

const OneClickTrading = ({ isOpen, onClose,onAccept }) => {
    const { darkMode } = useContext(ThemeContext);
    const [isAgreed, setIsAgreed] = useState(false);

    const handleAgreeChange = (event) => {
        setIsAgreed(event.target.checked);
    };


    const handleAccept = () => {
        if (isAgreed) {
            onAccept();
            onClose();
        }
    };
    return (
        <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm" PaperComponent={(props) => (
            <DraggableBox {...props} style={{ position: "absolute", top: "1%", left: "30%", transform: "translate(-50%, -50%)" }} />)}
            sx={{ "& .MuiDialog-paper": { backgroundColor: darkMode ? "#0f1720" : "var(--white)", color: darkMode ? "#d1d1d1" : "#333", boxShadow: darkMode ? "0px 16px 46px 8px rgba(0, 0, 0, 0.12)" : "0 10px 20px rgba(169, 169, 169, 0.3), 4px 4px 10px rgba(169, 169, 169, 0.2), -4px 4px 5px rgba(169, 169, 169, 0.1)", }, }}>
            <DialogTitle sx={{ padding: '12px', cursor: "move", display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: darkMode ? "#1976d2" : "#1976d2", color: "white", }} className="header">
                <Typography variant="body2">One Click Trading - Disclaimer</Typography>
                <CloseSharp onClick={onClose} sx={{ cursor: "pointer", fontSize: '18px' }} />
            </DialogTitle>

            <DialogContent sx={{ padding: 2, overFlowY: 'scroll', height: 350 }}>
                <Typography variant="caption">
                    You are about to activate One Click Trading mode. By clicking "I Accept these Terms and Conditions" below, you acknowledge that you have read and understood the following terms and conditions, and you agree to be bound hereby.
                    <br /><br />
                    You can activate or deactivate One Click Trading mode from the menu of your web terminal.
                    <br /><br />
                    The One Click Trading mode for order submission is a one-step process. Your order will be submitted when you:
                    <ul>
                        <li>tap either bid (SELL) or ask (BUY) price buttons on the One Click Trading panel of a chart</li>
                        <li>tap Sell, Close, Buy or order placing buttons in the Depth of Market window</li>
                        <li>close positions or delete orders in the Trade tab</li>
                    </ul>
                    <br />
                    THERE WILL BE NO SUBSEQUENT CONFIRMATION PROMPT FOR YOU TO CLICK. YOU WILL NOT BE ABLE TO WITHDRAW OR CHANGE YOUR ORDER ONCE YOU CLICK. UNDER NORMAL MARKET CONDITIONS AND SYSTEM PERFORMANCE, A MARKET ORDER WILL BE PROMPTLY FILLED AFTER SUBMISSION AND YOU WILL ENTER INTO A BINDING TRANSACTION.
                    <br /><br />
                    You agree to accept all risks associated with the use of the One Click Trading mode, including, without limitation, the risk of errors, omissions or mistakes made in submitting such order.
                    <br /><br />
                    You agree to fully indemnify and hold harmless {process.env.REACT_APP_COMPANY_NAME} Ltd. from any and all losses, costs and expenses that may incur as a result of any such errors, omissions or mistakes by you, or any other person trading on your behalf.
                </Typography>
            </DialogContent>

            <DialogActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box display='flex' justifyContent="flex-start" alignItems="center">
                    <FormControlLabel
                        control={<Checkbox checked={isAgreed} onChange={handleAgreeChange} />}
                        label="I Accept these Terms and Conditions" sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.85rem" }, color: darkMode ? "var(--lightText)" : 'black' }}
                    />
                </Box>
                <Box display="flex" justifyContent="flex-end" alignItems="center" gap={1}>
                    <Button onClick={onClose} variant="outlined" color="secondary">Cancel</Button>
                    <Button onClick={handleAccept} variant="contained" color="secondary" disabled={!isAgreed}>Accept</Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
};

export default OneClickTrading;
